import CarouselPermissions from "models/Permissions/AbstractPermissions/CarouselPermissions"
import ManualPermissions from "models/Permissions/AbstractPermissions/ManualPermissions"
import CommissionsPermissions from "../CommissionsPermissions"

class DashboardPermissions {
    constructor({ 
        show = true,
        enabled = true,
        comissions = {},
        carousel = {},
        manual = {},
    }) {
        this.show = show
        this.enabled = enabled
        this.comissions = new CommissionsPermissions(comissions)
        this.carousel = new CarouselPermissions(carousel)
        this.manual = new ManualPermissions(manual)
    }
}

export default DashboardPermissions
